import React from 'react';
import { useFormContext } from 'react-hook-form';

import { createStyles } from '../tss';
import { FormVona } from '../types/FormVona';
import { FormCheckbox } from './FormCheckbox';
import { FormDateTimePicker } from './FormDateTimePicker';
import { FormTextArea } from './FormTextArea';
import { FormTextInput } from './FormTextInput';
import { ValidationContainer } from './ValidationContainer';

const useStyles = createStyles(() => ({
  willUpdate: {
    width: 'auto',
    whiteSpace: 'nowrap',
  },
}));

export const FollowupInputs: React.FC = () => {
  const { classes } = useStyles();
  const form = useFormContext<FormVona>();
  const willUpdate = form.watch('willUpdate');
  return (
    <>
      <FormTextInput
        data-testid="input-contacts"
        fieldPath="contacts"
        label="Contact Details"
        tooltipContent="Contact details for the State Volcano Observatory."
      />
      <FormTextArea
        data-testid="input-remarks"
        fieldPath="remarks"
        label="Remarks"
        tooltipContent="Any additional information that may be useful."
      />
      <ValidationContainer hstack>
        <FormCheckbox
          data-testid="checkbox-will-update"
          dependants={['nextNotice']}
          fieldPath="willUpdate"
          label="Will update at:"
          checkboxProps={{ className: classes.willUpdate }}
          formControlProps={{ width: 'auto' }}
        />
        <FormDateTimePicker
          data-testid="date-picker-next-notice"
          disabled={!willUpdate}
          fieldPath="nextNotice"
          label="Next Notice (UTC)"
          tooltipContent="
  Indication of the issuance of next VONA. If there is no planned next VONA, leave
  empty (you can click &quot;clear&quot; in the dialog to empty it)."
        />
      </ValidationContainer>
    </>
  );
};
